import { Chip, ChipBackgroundColor, ChipSize } from "@amzn/stencil-react-components/chip";
import { Row, View } from "@amzn/stencil-react-components/layout";
import { Text, TextVariant } from "@amzn/stencil-react-components/text";
import { IconThumbUpExtraSmall } from "@amzn/stencil-react-icons";
import React, { FC } from "react";

export enum ReviewType {
  SELF = "User review",
  AI = "AI review",
}

export interface ProductReviewCardProps {
  content: string;
  jobFamily: string;
  reviewType?: ReviewType;
  votes?: number;
}

// this is currently filled with data only for scaffolding
export const ProductReviewCard: FC<ProductReviewCardProps> = ({ votes, content, reviewType, jobFamily }) => {
  const renderChip = () => {
    if (reviewType) {
      return (
        <Chip backgroundColor={ChipBackgroundColor.Blue} size={ChipSize.ExtraSmall} dataTestId="product-review-chip">
          <Text>{reviewType}</Text>
        </Chip>
      );
    }
  };

  return (
    <View style={{ marginTop: "16px", marginBottom: "8px" }} dataTestId="product-review-card">
      {renderChip()}
      <Row justifyContent="space-between" style={{ marginTop: "16px", marginBottom: "8px" }}>
        <Text variant={TextVariant.HeadingSM} dataTestId="product-review-author-job-family">
          {jobFamily}
        </Text>
        {/* DISABLED UNTIL EVERYTHING IS ENABLED */}
        {/* <Row alignItems="center">
          <IconThumbUpExtraSmall />
          <Text>{votes}</Text>
        </Row> */}
      </Row>
      <Text>{content}</Text>
    </View>
  );
};
